var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "status-container" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.statusChange },
          model: {
            value: _vm.status,
            callback: function($$v) {
              _vm.status = $$v
            },
            expression: "status"
          }
        },
        [
          _c("el-tab-pane", { attrs: { label: "全部商品", name: "" } }),
          _c("el-tab-pane", { attrs: { label: "出售中", name: "5" } }),
          _c("el-tab-pane", { attrs: { label: "已下架", name: "6" } }),
          _c("el-tab-pane", { attrs: { label: "待审核", name: "2" } }),
          _c("el-tab-pane", { attrs: { label: "驳回", name: "3" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }